import { HeroPrimary1Type } from "../../types/heroTypes"
import { API } from "../../constants/constants"
import PrimaryButton from "../common/PrimaryButton"
import BaseHeadline from "../common/BaseHeadline"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import BaseQuoteText from "../common/BaseQuoteText"
import { useNavigate } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore from "swiper"
import { Autoplay } from "swiper/modules"
import { ReactComponent as BLUR } from "../../assets/blur.svg"

// Import Swiper styles
import "swiper/css"

export default function HeroPrimary1(props: HeroPrimary1Type) {
    const navigate = useNavigate()

    SwiperCore.use([Autoplay])

    const getShade = (shade?: string): string => {
        if (shade?.includes("heroPrimary1WelcomeQuoteColorLight")) return "bg-base-200"
        if (shade?.includes("heroPrimary1WelcomeQuoteColorSuperLight")) return "bg-base-300"
        if (shade?.includes("heroPrimary1WelcomeQuoteColorWhite")) return "bg-accent"
        if (shade?.includes("heroPrimary1WelcomeQuoteColorPrimary")) return "bg-base-100"
        if (shade?.includes("heroPrimary1WelcomeQuoteColorOptional")) return "bg-info"
        return ""
    }

    return (
        <div className="w-full pb-4">
            {/* UPPER PART */}
            <div className="w-full h-[70vh] bg-cover bg-center flex items-end rounded-t-xl -mb-4 relative">
                <Swiper
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    navigation={false}
                    className="!absolute !inset-0 !w-full !h-full">
                    {props.heroPrimary1Background?.map((slide, index) => {
                        const media = slide.heroPrimary1BackgroundImage
                        return (
                            <SwiperSlide key={index} className="">
                                {media.isVideo ? (
                                    <video
                                        className="w-full h-full object-cover"
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        webkit-playsinline
                                    >
                                        <source src={API + media.url} type={media.mimeType} />
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <img className="w-full h-full object-cover" src={API + media.url} alt={media.description ?? media.name} />
                                )}
                            </SwiperSlide>
                        )
                    })}
                </Swiper>

                <div className="relative pb-16 md:pb-24 px-4 md:pl-8 w-full h-full flex flex-col items-start justify-end rounded-tr-full z-10">
                    <BaseHeadline headlineType={1} label={props?.heroPrimary1Heading} classProps="!text-primary relative z-[11]" />
                    <BaseRichtext content={props.heroPrimary1Text} classProps="font-semibold !text-primary relative z-[11]" />
                </div>
                <BLUR className="absolute h-[70vh] inset-0 fill-base-200 z-[5]" />
                <BLUR className="absolute h-[70vh] inset-0 fill-base-200 z-[5]" />
                <BLUR className="absolute hidden sm:block h-[70vh] inset-0 fill-base-200 z-[5]" />
            </div>
            {/* BOTTOM PART */}
            <div className="w-full bg-base-200 rounded-default pt-16 py-48 -mb-32 relative z-10">
                <div className="max-w-content mx-auto">
                    <div className="flex flex-col md:flex-row items-center gap-8 px-4">
                        <div>
                            <BaseSubheadline label={props?.heroPrimary1WelcomeHeading} />
                            <BaseRichtext content={props?.heroPrimary1WelcomeText} classProps="pb-4" />
                            <PrimaryButton
                                text={props?.heroPrimary1WelcomeButton}
                                onClick={() => {
                                    if (props.heroPrimary1WelcomeButtonUrl.includes("https://")) {
                                        window.open(props.heroPrimary1WelcomeButtonUrl, "_blank")
                                    } else {
                                        navigate(props.heroPrimary1WelcomeButtonUrl)
                                    }
                                }}
                                active={true}
                            />
                        </div>
                        <img
                            src={API + props?.heroPrimary1WelcomeImage?.url}
                            alt={props.heroPrimary1WelcomeImage?.description ?? props.heroPrimary1WelcomeImage.name ?? "WelcomeImageAltTag"}
                            className="w-full h-64 md:h-auto md:w-1/2 md:aspect-square object-cover border-4 border-base-300 rounded-default"
                        />
                    </div>
                </div>
            </div>
            <div className={`max-w-content w-full mx-auto pt-16 pb-12 flex flex-col items-center rounded-default relative z-10 ${getShade(props.heroPrimary1WelcomeQuoteColor) || 'bg-base-100'}`}>
                <div className="flex max-w-content-sm justify-center items-center gap-2 pb-6 px-4">
                    <BaseQuoteText 
                    text={props.heroPrimary1WelcomeQuote} 
                    author={props.heroPrimary1WelcomeQuoteAuthor}
                    isQuoteWhite={props.heroPrimary1SettingQuoteColor} />
                </div>
                <img
                    src={API + props.heroPrimary1WelcomeIconQuote?.url}
                    alt={props.heroPrimary1WelcomeIconQuote?.description ?? props.heroPrimary1WelcomeIconQuote?.name ?? "HeroPrimaryWelcomeQuote"}
                    className="h-12 max-w-[4rem] object-contain"
                />
            </div>
        </div>
    )
}
